import { grapheneTimeDeltaToNumeric } from '@/utils/time'

interface TimeEntryHours {
  totalOrdinary?: string | null
  totalWork?: string | null
}

function timeDeltaToSeconds(timeDelta: string | null | undefined): number {
  if (!timeDelta) return 0

  const negative = timeDelta.startsWith('-')
  const seconds = grapheneTimeDeltaToNumeric(
    negative ? timeDelta.slice(1) : timeDelta
  )
  if (seconds === null) return 0

  return negative ? -seconds : seconds
}

/**
 * Total hours worked across the given time entries, in seconds. Reads the same
 * value the table shows per row: `totalOrdinary` when the backend supplies it,
 * `totalWork` otherwise.
 */
export function sumTimeEntryHours(entries: TimeEntryHours[]): number {
  return entries.reduce(
    (total, entry) =>
      total + timeDeltaToSeconds(entry.totalOrdinary ?? entry.totalWork),
    0
  )
}
